'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';

import 'angular-validation-match';

import {
  routeConfig
} from './app.config';

// import _Auth from '../components/auth/auth.module';
import FB from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';

// Directives 
import bcnavbar from '../components/directives/bcnavbar/bcnavbar.directive';
import messagesidebar from '../components/directives/messagesidebar/messagesidebar.directive';
import sidebarnav from '../components/directives/sidebarnav/sidebarnav.directive';
import sidebarfooter from '../components/directives/sidebarfooter/sidebarfooter.directive';
import mainheaderauth from '../components/directives/mainheaderauth/mainheaderauth.directive';
import sidebaractivity from '../components/directives/sidebaractivity/sidebaractivity.directive';
import furtherguidance from '../components/directives/furtherguidance/furtherguidance.directive';
import mapsidebar from '../components/directives/mapsidebar/mapsidebar.directive';
import maptoolbar from '../components/directives/maptoolbar/maptoolbar.directive';
import selecthousingpolicies from '../components/directives/selecthousingpolicies/selecthousingpolicies.directive';
import maintocselection from '../components/directives/maintocselection/maintocselection.directive';
import maintocselectiondensity from '../components/directives/maintocselectiondensity/maintocselectiondensity.directive';
import note from '../components/directives/note/note.directive';
import pageintro from '../components/directives/pageintro/pageintro.directive';
import statuspills from '../components/directives/statuspills/statuspills.directive';
import submissionsectionsubmit from '../components/directives/submissionsectionsubmit/submissionsectionsubmit.directive';
import submissionsectionconfirmation from '../components/directives/submissionsectionconfirmation/submissionsectionconfirmation.directive';
import handsontable from '../components/directives/handsontable/handsontable.directive';
import tablesortbuttons from '../components/directives/tablesortbuttons/tablesortbuttons.directive';
import dropdown from '../components/directives/dropdown/dropdown.directive';
import notificationmessages from '../components/directives/notificationmessages/notificationmessages.directive';
import tabmodal from '../components/directives/tabmodal/tabmodal.directive'

// Pages 
import parking from './account/parking/parking.component';
import parking_requirements from './account/parking/parking_requirements/parking_requirements.component';
import vehicle_parking from './account/parking/vehicle_parking/vehicle_parking.component';
import parking_policies from './account/parking/parking_policies/parking_policies.component';
import bicycle_parking from './account/parking/bicycle_parking/bicycle_parking.component';
import data from './account/data/data.component';
import map from './account/map/map.component';
import dashboard from './account/dashboard/dashboard.component';
import myaccount from './account/myaccount/myaccount.component';
import density from './account/density/density.component';
import density_requirements from './account/density/density_requirements/density_requirements.component';
import density_compliance from './account/density/density_compliance/density_compliance.component';
import commercial_uses from './account/density/commercial_uses/commercial_uses.component';
import residential_uses from './account/density/residential_uses/residential_uses.component';
import housing from './account/housing/housing.component';
import housing_requirements from './account/housing/housing_requirements/housing_requirements.component';
import guidance from './account/housing/guidance/guidance.component';
import commercial_stabilization from './account/housing/commercial_stabilization/commercial_stabilization.component';
import housing_preservation from './account/housing/housing_preservation/housing_preservation.component';
import housing_production from './account/housing/housing_production/housing_production.component';
import housing_protection from './account/housing/housing_protection/housing_protection.component';
import manageusers from './admin/manageusers/manageusers.component';
import stations from './admin/stations/stations.component';
import stationaccess from './account/stationaccess/stationaccess.component';
import station_requirements from './account/stationaccess/station_requirements/station_requirements.component';
import analysis_improvement_program from './account/stationaccess/analysis_improvement_program/analysis_improvement_program.component';
import complete_streets from './account/stationaccess/complete_streets/complete_streets.component';
import mobility_hub from './account/stationaccess/mobility_hub/mobility_hub.component';
import project_prioritization from './account/stationaccess/project_prioritization/project_prioritization.component';
import feedback from './admin/feedback/feedback.component';
import compliance from './account/compliance/compliance.component';
import submissions from './account/compliance/submissions/submissions.component';
import jurisdictions from './account/compliance/jurisdictions/jurisdictions.component';
import station_areas from './account/compliance/station_areas/station_areas.component';
import toc_policy from './account/toc_policy/toc_policy.component';
import documents from './account/toc_policy/documents/documents.component';
import registerSuccess from './account/register-success/register-success.component';
import accountNotActive from './account/account-not-active/account-not-active.component';
import messages from './account/messages/messages.component';
import messageDetail from './account/messages/message-detail.component';
import message from './account/message/message.component';
import zoning_updates from './account/zoning_updates/zoning_updates.component.js';


// Services
import baseConfigService from '../components/services/baseConfig/baseConfig.service';
import userService from '../components/services/users/users.service';
import feedbackService from '../components/services/feedbackService/feedbackService.service';
import navService from '../components/services/navService/navService.service';
import fetchService from '../components/services/fetch/fetch.service';
import lookupService from '../components/services/lookup/lookup.service';
import mapService from '../components/services/map/map.service';
import fileUploadService from '../components/services/fileUploadService/fileUploadService.js';


// Libraries
import firebase from 'angularfire';
import smartTable from 'angular-smart-table';

import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@fortawesome/fontawesome-pro/css/v4-shims.min.css';


import './app.css';

angular.module('tocApp', [ngCookies, ngResource, ngSanitize, uiRouter, account, admin,
  'validation.match', navbar, footer, main, constants, util, parking, data, map, dashboard, myaccount, zoning_updates, stationaccess, compliance, jurisdictions, station_areas, submissions,
   commercial_stabilization, housing_preservation, housing_production, housing_protection, registerSuccess,accountNotActive, density, commercial_uses, parking_requirements, station_requirements, density_requirements, housing_requirements, density_compliance,
  residential_uses, housing, vehicle_parking, parking_policies, bicycle_parking, analysis_improvement_program, guidance,
  mobility_hub, project_prioritization, complete_streets, toc_policy, documents, manageusers, feedback, stations, baseConfigService, userService, feedbackService, navService, bcnavbar, sidebarnav, 
  sidebarfooter, mainheaderauth, messagesidebar, sidebaractivity, mapsidebar, maptoolbar, selecthousingpolicies, maintocselection, maintocselectiondensity,
  note, tabmodal, pageintro, statuspills, submissionsectionsubmit,submissionsectionconfirmation, handsontable, tablesortbuttons,
  messages, message, messageDetail, dropdown, 'firebase', smartTable, fetchService, fileUploadService,lookupService,mapService, notificationmessages])
  .config(routeConfig)
  .run(function($rootScope, $location, Auth, FB, $cookies, navService, $timeout) {
    'ngInject';
    
    // Redirect to login if route requires auth and you're not logged in
    // $rootScope.$on('$stateChangeStart', function(event, next) {
    //   Auth.isLoggedIn(function(loggedIn) {
    //     if(next.authenticate && !loggedIn) {
    //       $location.path('/login');
    //     }
    //   });
    // });

   
    $rootScope.$on('$stateChangeStart', function(event, next) {
      if(!$cookies.get('token') && next.authenticate){
        $location.path('/login');
      }
     
    });

    




  });


angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['tocApp'], {
      strictDi: false
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js